import api from '../_api';

const actions = {
    paymentRequest: ({commit, dispatch}) => {

        return new Promise((resolve, reject) => {
            commit('PAYMENT_LOADING');

            api.payments()
                .then((resp) => {
                    commit('PAYMENT_SUCCESS', resp.data.data);
                    // resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('PAYMENT_ERROR', errors);
                    // reject(err.response);
                });
        })
    },
    clearPaymentErrors:({commit}) => {
        commit('CLEAR_PAYMENT_ERRORS');
    },
}

export default actions
